import { graphql } from '@repo/common/queries/schemas/subgraph_telemetry_query'

export const query_get_token_holders = graphql(`
  query query_get_token_holders(
    $first: Int = 100
    $skip: Int = 0
    $token: String!
  ) {
    tokenHolders(
      first: $first
      skip: $skip
      orderBy: balance
      orderDirection: desc
      where: { token: $token }
    ) {
      id
      wallet_address
      balance
      first_transaction_at
      last_transaction_at
      max_balance
      transaction_count
    }
  }
`)
